import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetLicencesTableData: '[GetLicencesTableData] Action',
  SetLicencesData: '[SetLicencesData] Action',
  GetLicencesTranslateData: '[GetLicencesTranslateData] Action',
}

const initialLicencesState: ILicencesState = {
  licenceColumnList: [],
  licenceColumnValues: [],
  licenceDefinitions: [],
  licenceColumnNames: [],
  licenceDataTypes: [],
  licenceDe: [],
  licenceEn: [],

  licencesOptions: []
}

export interface ILicencesState {
  licenceColumnValues: [],
  licenceColumnList: [],
  licenceDefinitions: []
  licenceColumnNames: [],
  licenceDataTypes: [],
  licenceDe: [],
  licenceEn: [],

  licencesOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-Licences', whitelist:  [ ] },
  (state: ILicencesState = initialLicencesState, action: any) => {
    switch (action.type) {
      case actionTypes.GetLicencesTableData: {
        const licenceColumnValues = JSON.parse(action.payload.data.licences);
        let headers = JSON.parse(action.payload.data.headers);
        let licenceDefinitions = JSON.parse(action.payload.data.definitions);
        let licencesOptions = JSON.parse(action.payload.data.options);
        let licenceColumnNames = action.payload.data.columnNames;
        let licenceDataTypes = action.payload.data.dataTypes;
        let licenceColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          licenceColumnList.push(newElement[0]);
        });
        return { ...state, licenceColumnList, licenceColumnValues, licenceDefinitions, licencesOptions, licenceDataTypes , licenceColumnNames};
      }
    
      case actionTypes.SetLicencesData: {
        const licenceColumnValues = action.payload.data;
        return { ...state, licenceColumnValues };
      }

      case actionTypes.GetLicencesTranslateData: {
        const licenceDe = JSON.parse(action.payload.data.de);
        const licenceEn = JSON.parse(action.payload.data.en);
        return { ...state, licenceDe, licenceEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getLicencesTableData: (data: any) => ({ type: actionTypes.GetLicencesTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetLicencesTranslateData, payload: { data } }),
  setLicencesData: (data: any) => ({ type: actionTypes.SetLicencesData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
